import { Checkbox, FormControl, FormControlLabel, FormHelperText, FormLabel } from '@mui/material';

interface ComponentTipoDecretoProps {
  labelText?: string;
  formik?: any | null;
  label?: string;
  value?: string;
  onChange?: (value: string) => void;
}

export default function ComponentTipoDecreto({
  labelText,
  formik,
  label,
  value,
  onChange,
}: ComponentTipoDecretoProps): JSX.Element {

  const handleChange = (selectedValue: string) => {
    if (formik && label) {
      formik.setFieldValue(label, selectedValue);
    }
    onChange?.(selectedValue);
  }

  const getCurrentValue = () => {
    if (formik && label) {
      return formik.values[label];
    }
    return value;
  }

  const lista_tipo_publicacao = [
    {
      label: 'Lei Municipal',
      value: 'lei_municipal',
    },
    {
      label: 'Decreto',
      value: 'decreto',
    },
    {
      label: 'Portaria',
      value: 'portaria',
    },
    {
      label: 'Resolução',
      value: 'resolucao',
    },
    {
      label: 'Instrução Normativa',
      value: 'instrucao_normativa',
    },
    {
      label: 'Outros',
      value: 'outros',
    },
  ];

  return (
    <FormControl>
      <FormLabel
        id={`${label}-label`}
        htmlFor={`${label}-label`}
        error={formik?.errors[label!] ? true : false}
        sx={{
          color: '#333',
          fontWeight: 'bold',
        }}
      >
        {labelText}
      </FormLabel>
      {formik?.errors[label!] && (
        <FormHelperText error>{formik?.errors[label!]}</FormHelperText>
      )}

      {lista_tipo_publicacao.map((item) => (
        <FormControlLabel

          key={item.value}
          control={
            <Checkbox
              checked={getCurrentValue() === item.value}
              onChange={() => handleChange(item.value)}
            />
          }
          label={item.label}
        />
      ))}
    </FormControl>
  );
}
